export default "__VITE_ASSET__ROHdqo3f__"